import { render } from "./dueDiligenceDetail.vue?vue&type=template&id=516754d6&scoped=true&ts=true"
import script from "./dueDiligenceDetail.vue?vue&type=script&lang=ts"
export * from "./dueDiligenceDetail.vue?vue&type=script&lang=ts"

import "./dueDiligenceDetail.vue?vue&type=style&index=0&id=516754d6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516754d6"]])

export default __exports__